require('../controllers/help_manager.js');
require('./viewing_operations.js');
require('./hoveringState.js');
require('./idleState.js');
require('./infoGatheringState.js');
require('./validatingState.js');
require('./resizing_canvas.js');

Pegasus.UploadingImageFromUrlState = Em.State.extend({
  enter: function(){
    this._super();
    var translation = Em.I18n.t('g.loading');
    var mask = $('.image-loader').length ? $('.image-loader') : $('<div class="image-loader loader-mask"><div class="loading-wrapper"><div class="loading show">'+translation+'...</div></div></div>');
    mask.remove().appendTo('body');
  },
  exit: function(){
    var uploadController = Pegasus.lookupController('upload');

    $('.image-loader').remove();

    uploadController.setProperties({
      fileData: null,
      uploadData: null,
      uploadXHR: null,
      dataSrcProxy: ''
    });
  },

  setup: function(manager, context){
    manager.send('saveImageFromUrl');
  },

  saveImageFromUrl: function(manager){
    var maxWidth = Pegasus.lookupController('toolbar').get('imageHandler.maxImageWidth');
    var isHost = new RegExp(window.location.host, 'i'),
      isData = /^data/,
      url = Pegasus.lookupController('upload').get('fileData.upload.uploadUrl');

    if ( isHost.test(url) || isData.test(url) ) {
      var data = {
        encoded: url
      };

      manager.transitionTo( 'idling' );
      manager.send('didComplete', data);
      return;
    }

    var callback = function(data){
      manager.transitionTo( 'idling' );
      manager.send('didComplete', data);
    }.bind(this);

    try {
      $(url); // if it's not an svg this will throw
      window.svgConverter(url, callback);
      return;
    }catch(e){
    }

    var errorCallback = function(){
      $(window).
        off('didReceiveImageTransformation').
        one('didReceiveImageTransformation', function(e, data){
          if ( data.isSuccess ) {
            Em.run(null, callback, data.data);
            return;
          }

          manager.send('errorProcessingImage', data.data);
        });

      Pegasus.lookupRouter().send('externallyEncodeImage', url);
    };

    // if it doesn't allow CORS this will throw
    window.convertToDataURLviaCanvas( url, callback, errorCallback, 'image/png', maxWidth);
  }
});


Pegasus.StateMachine = Ember.StateManager.extend({
  initialize: function(){
    this.transitionTo('initializing');
  },

  didCancelUpload: function(manager){
    if ( manager.jqXHR ) {
      if ( manager.jqXHR.abort ) {
        manager.jqXHR.abort();
      }
      manager.set('jqXHR', null);
    }
  },

  hoverRow: function(manager, row){
    if ( Pegasus.lookupController('rowOperations').get('content') !== row ) {
      $('.popped-row').removeClass('popped-row');
      $('.selected-mirror-column').removeClass('selected-mirror-column');
      Pegasus.lookupController('rowOperations').set('content', row);
    }
  },

  hideControls: Em.K,

  didChangeEditorContext: function(manager){
    var router = Pegasus.lookupRouter();
    Em.run.cancelTimers();
    window.featherEditor.close();
    router.send('clearPreview');
    Pegasus.set('canvasInstance', null);
    this.clearObservers();
    Em.run.next( manager, 'initialize');
  },

  clearObservers: function(){
    this.observersForKey('currentPath').clear();
  },

  initializing: Pegasus.InitializingState,
  saved: Pegasus.BaseState.extend({
    didSave: function(){
      Pegasus.stateMachine.transitionTo('idling');
    },
    hover: function(){
      Pegasus.stateMachine.transitionTo('idling');
    }
  }),
  hovering: Pegasus.HoveringState.extend(),
  idling: Pegasus.IdlingState.extend(),
  viewingOperations: Pegasus.ViewingOperationsState.extend(),
  validating: Pegasus.ValidatingState.extend(),
  infoGathering: Pegasus.InfoGatheringState.extend(),
  resizingCanvas: Pegasus.ResizingCanvasState.extend(),
  closeModal: function(){
    Pegasus.lookupController('modal').setProperties({
      presenter: null
    });
  },
  didValidDrop: Ember.K,
  didSave: function(){
    Pegasus.stateMachine.transitionTo('saved');
  },

  didComplete: function(manager, data){
    var dataSrc = data.encoded,
      uploadController = Pegasus.lookupController('toolbar');

    uploadController.send('didFinishUploading', data);

    var uploader = $('<img/>');

    uploader.imagesLoaded().
      done(Em.K).
      fail( function(){
        Ember.run( function(){
          manager.send('errorProcessingImage');
        });
      }).attr('src', dataSrc);
  },

  uploadingImageFromUrl: Pegasus.UploadingImageFromUrlState.extend(),

  saveCustomImage: function(manager, id, url, callback, fakeElement){
    var toolbarController = Pegasus.lookupController('toolbar');
    var pass = function(data){
        var dataSrc = data.encoded;
        Em.run.next( function(){
          callback = callback || toolbarController.get('imageHandler.imageCompletionCallback');
          Pegasus.set('status', 'editing');

          if (callback){
            return callback(data, id);
          }
          else {
            Pegasus.lookupController('upload').set('originalDataSrc', dataSrc);
            Pegasus.lookupController('toolbar').set('dataSrc', dataSrc);
          }
        });
      },
      fail = function(data){
        Pegasus.set('status', 'editing');
        //Pegasus.get('externalProxy').send('showNotification', "error", Em.I18n.t('editor.payload.error'));
      };

    convertToDataURLviaCanvas( url, pass, fail, 'image/png', toolbarController.get('imageHandler.maxImageWidth') )
  },

});

Pegasus.StateMachine.reopen({
  helpManager: function(){
    return Pegasus.HelpManager.create();
  }.property(),
  dismissHelpContext: function(){
    this.set('activeHelpContext.isDismissed', true);
    this.set('activeHelpContext', this.get('helpManager.idling'));
    this.get('helpManager.idling').position();
  },
  setHelpContext: function(name){
    var helpContext = this.get('helpManager.' + name );
    if ( helpContext && !helpContext.get('isDismissed') ) {
      Em.run.next(this, function(){
        this.set('activeHelpContext', helpContext);
        helpContext.position();
      });
    }
  },
  transitionTo: function(state, context){
    var result = this._super.apply(this, arguments);

    if ( this.get('shouldShowHelp') ) {
      this.setHelpContext( state.camelize() );
    }

    Em.set( 'Pegasus.subStatus', state.camelize() );

    return result;
  },
});
